/*
 * @Author: your name
 * @Date: 2022-04-22 16:40:43
 * @LastEditTime: 2022-04-22 16:40:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kkl-log\src\config.js
 */
/**
 * 项目名
 */
export const LogProject = {
    /** 新航线实时计算 */
    blink: 'xhx-blink',

    /** 日志 */
    log: 'kkl-log',

    /** 飞鸽 */
    flyPigeon: 'xhx-fly-pigeon',
};

/**
 * 日志存储仓库
 */
export const LogStrore = {
    /** 实时计算 */
    blink: 'xhx_blink_store',

    /** 业务日志 */
    biz: 'kkl-log-biz',

    /** 系统日志 */
    sys: 'kkl-log-sys',

    /** 大数据埋点日志 */
    bigData: 'kkl-log-bigdata',

    /** 飞鸽日志 */
    flyPigeon: 'fly-pigeon',
};

export const LogTopic = {
    /**
     * 直播间相关日志，包含直播录像回放日志
     * @description 直播录像回放、看课时长、答题、播放模块、直播间基础模块、校园争霸赛、发言、录播视频播放状态、服务端状态改变、举手模块、老师送礼、禁言模块、红包模块、分层考试、校园pk
     */
    live: 'live',

    /**
     * 飞鸽日志
     * @description 学习时长: 直播间内 默认60s上报一次 (MQTT)、卡顿上报: 直播间内
     */
    flyPigeon: 'fly-pigeon',

    /**
     * 录播商品日志
     */
    vod: 'vod',

    /**
     * 页面埋点日志
     */
    page: 'page',

    /**
     * ai录播课
     */
    aiVod: 'aivod',

    /**
     * 网关上报
     */
    gateway: 'gateway',
    
    /**
     * 监控日志
     */
    biz_monitor: 'biz_monitor',
};

export const LogEnv = {
    /**
     * 开发环境 | 默认
     */
    dev: 'dev',

    /**
     * sit环境
     */
    sit: 'sit',

    /**
     * 线上
     */
    prod: 'prod',
};

export const _logLevel = {
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    fatal: 6,
};

export const HOST = 'cn-hangzhou.log.aliyuncs.com';